import $ from 'jquery';
import _ from 'underscore';
import ProsController from './ProsController';
import Constants from '../util/Constants';
import PurchaseHistoryPage from '../page/customLogic/PurchaseHistoryPage';
import PurchaseDetailPage from '../page/customLogic/PurchaseDetailPage';
import HomePage from '../page/customLogic/HomePage';
import Util from '../util/Util';
import KillSwitchUtil from '../util/KillSwitchUtil';
import ProsZones from '../util/ProsZones';
import ProsDOMUtil from '../util/ProsDOMUtil';

const PAGE_CONFIGURATION = {
  DEFAULT: {
    swatch: true,
    selector: Constants.CLASS_SELECTOR,
  },
  [Constants.PAGE.HOME_PAGE]: {
    imageWidth: 296,
    swatch: true,
    arrowIconSize: 'small',
    overlayButtons: true,
    customLogicClass: HomePage,
  },
  [Constants.PAGE.SEARCH_PAGE]: {
    rvi: true,
    overriddenZoneName: ProsZones.SEARCH_PAGE.SEARCH_ZONE_A,
  },
  [Constants.PAGE.BROWSE_PAGE]: {
    rvi: true,
    overriddenZoneName: ProsZones.BROWSE_PAGE.BROWSE_ZONE_A,
  },
  [Constants.PAGE.CAT_SPLASH_PAGE]: {
    rvi: true,
    overriddenZoneName: ProsZones.CAT_SPLASH_PAGE.C2FLEX_ZONE_D,
  },
  [Constants.PAGE.PURCHASE_HISTORY_PAGE]: {
    customLogicClass: PurchaseHistoryPage,
  },
  [Constants.PAGE.PURCHASE_DETAIL_PAGE]: {
    customLogicClass: PurchaseDetailPage,
  },
};

const PAGE_PROPERTIES = {
  DEFAULT: {
    discovery: true,
  },
  HOME_PAGE: {
    redesignHomePageThumbnailEnabled: true,
  },
};

const { PAGE } = Constants;

const ZONE_PAGE_MAPPING = {
  HP_ZONE: PAGE.HOME_PAGE,
  C2FLEX_ZONE: PAGE.CAT_SPLASH_PAGE,
};

export default class MainPageController {
  constructor(opts) {
    const options = opts || {};
    this.selector = $(Constants.CLASS_SELECTOR);
    if (this.selector.length === 0) {
      return;
    }
    this.options = options;
    this.page = options.page || this.lookForPageType();
    this.configuration = this.getConfiguration();
  }

  getConfiguration() {
    const { page } = this;
    const customCarouselOptions = Object.assign({}, PAGE_CONFIGURATION.DEFAULT, PAGE_CONFIGURATION[page]);
    const customProperties = Object.assign({}, PAGE_PROPERTIES.DEFAULT, PAGE_PROPERTIES[page]);

    if (customCarouselOptions && customCarouselOptions.customLogicClass) {
      const CustomLogicLass = customCarouselOptions.customLogicClass;
      this.customLogicInstance = new CustomLogicLass(this);
    }
    return Object.assign({ page }, customCarouselOptions, { customProperties });
  }

  lookForPageType() {
    const element = this.selector.first();
    const { context } = element.data();
    let zone = context.substring(0, context.length - 2);
    /* istanbul ignore next */
    if (Util.hasMultiZoneContext(context)) {
      zone = `${context.substring(0, context.indexOf('_'))}_ZONE`;
    }

    return ZONE_PAGE_MAPPING[zone];
  }

  render() {
    if (this.selector.length === 0) {
      return;
    }
    if (this.customLogicInstance) {
      this.customLogicInstance.apply().then((proceed) => {
        if (proceed) {
          this.loadPros();
        }
      });
    } else {
      this.loadPros();
    }
  }

  lookForRVIRelatedZones() {
    const rviItems = Util.getRecentlyViewedItems();
    if (rviItems.length && KillSwitchUtil.isTrue('rviRelatedProsZonesEnabled')) {
      this.configuration.recentlyViewedItems = _.first(rviItems, 30).join('|');
      this.selector.filter('.above-rvi').attr('data-context', this.configuration.overriddenZoneName).attr('data-productid', rviItems[0]);
    } else {
      ProsDOMUtil.hide(this.selector.filter('.above-rvi'));
    }
  }

  loadPros() {
    if (this.configuration.rvi) {
      this.lookForRVIRelatedZones();
    }
    const prosController = new ProsController(this.configuration);
    prosController.render();
  }
}
